import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import api from "./api";
import { sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";

export function downloadAssetImage(assetHierarchyId) {
  return async (dispatch, getState) => {
    try {
      let image = getState().assetData.images[assetHierarchyId];
      if (image) return image;

      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.downloadAssetImage(assetHierarchyId),
          "DownloadAssetImage",
          [eventTypes.ASSET_IMAGE_DOWNLOADED],
          false
        )
      );

      if (event.ok) {
        image = event.eventBody.imageUrl;
        dispatch({
          type: actionTypes.DOWNLOAD_ASSET_IMAGE_SUCCESS,
          payload: { id: assetHierarchyId, image }
        });

        return image;
      }
    } catch (error) {
      console.log(error.message);
    }
  };
}
